<template>
  <div class="fillmaterials">
    <div class="fillmaterialsTitle">
      <div class="fillmaterialsTitle-wrap">
        <el-breadcrumb separator="|">
          <el-breadcrumb-item :to="{ path: '/' }"
            ><i class="el-icon-arrow-left"></i> 返回</el-breadcrumb-item
          >
          <el-breadcrumb-item>填写材料</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="fillmaterialsMsg">
      <div class="fillmaterialsMsg-step">
        <li
          v-for="(item, index) in stepList"
          :key="index"
          :class="actived(index)"
        >
          <p>
            <em class="before"></em>
            <span>{{ item }}</span>
            <i></i>
          </p>
        </li>
      </div>
      <div></div>
    </div>
    <div class="fillmaterialsMain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      stepList: [
        '申请人信息',
        '实时计划',
        '企业人员情况',
        '股东情况',
        '其他材料'
      ]
    };
  },
  computed: {
    ...mapState({
      activedIndex: state => state.qffillmaterials.activedIndex
    })
  },
  methods: {
    actived(index) {
      if (index == this.activedIndex) {
        return 'actived';
      } else if (index < this.activedIndex) {
        return 'finish';
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss">
.fillmaterials {
  width: 100%;
  background: #f5f5f6;
  padding-bottom: 1px;
  .fillmaterialsTitle {
    width: 100%;
    padding: 19px 0;
    background: #fff;
    .fillmaterialsTitle-wrap {
      width: 1200px;
      margin: 0 auto;
      .el-breadcrumb__item {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
      }
      .is-link {
        color: rgba(255, 106, 0, 1);
      }
    }
  }
  .fillmaterialsMsg {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .fillmaterialsMain {
    width: 1200px;
    margin: 0 auto;
  }
}
.fillmaterialsMsg-step {
  width: 100%;
  margin: 30px 0 20px 0;
  display: flex;
  li {
    // width: 24%;
    flex: 1;
    display: list-item;
    text-align: center;
    float: left;
    margin-right: 8px;
    background: #ebecec;
    border-top: 1px solid #ebecec;
    height: 40px;
    position: relative;
    p {
      display: block;
      padding: 8px 0;
      cursor: pointer;
      height: 40px;
      box-sizing: border-box;
      span {
        vertical-align: middle;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9ea1a2;
        line-height: 17px;
        display: inline-block;
        overflow: hidden;
        text-align: center;
        width: 75%;
      }
      i {
        float: right;
        width: 28px;
        height: 28px;
        margin: 3px 0px 0px 3.5px;
        top: 2px;
        right: -14px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        background: #ebecec;
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        position: absolute;
        z-index: 22;
      }
      em.before {
        width: 28px;
        height: 28px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        float: left;
        margin: -3px 10px 0px -14.5px;
        top: 2px;
        background: #f5f5f6;
        z-index: 2;
      }
    }
  }
  li:first-child {
    em.before {
      background: none;
    }
  }
  li:last-child {
    margin-right: 0;
    i {
      background: none !important;
    }
  }
  .finish {
    border-top: 1px solid #ffb35d;
    border-bottom: 1px solid #ffb35d;
    background: #ffb35d !important;
    color: #fff;
    span {
      color: #fff;
    }
    i {
      background: #ffb35d !important;
    }
  }
  .actived {
    border-top: 1px solid #ff8a01;
    border-bottom: 1px solid #ff8a01;
    background: #ff8a01 !important;
    color: #fff;
    span {
      color: #fff;
    }
    i {
      background: #ff8a01 !important;
    }
  }
}
</style>
